import React, { type ReactNode } from 'react';

import { SkeletonBar, SkeletonCode, SkeletonMilestone, SkeletonPrice, StyledSkeleton } from './styles';

export interface SkeletonProps {
    children?: ReactNode;
}

export function Skeleton({ children }: SkeletonProps) {
    return (
        <StyledSkeleton>
            <SkeletonBar />

            <SkeletonMilestone>
                <SkeletonPrice />
                <SkeletonCode />
            </SkeletonMilestone>

            {children}
        </StyledSkeleton>
    );
}
